import {
  DELETE_BRANCH_PROVIDER,
  DELETE_BRANCH_PROVIDER_FAILURE,
  DELETE_BRANCH_PROVIDER_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const deleteBranchListReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_BRANCH_PROVIDER:
      return { ...state, loading: true };
    case DELETE_BRANCH_PROVIDER_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case DELETE_BRANCH_PROVIDER_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default deleteBranchListReducer;
